import React from 'react';
import classnames from 'classnames';
import s from './BackgroundImage.scss';
export const BackgroundImage = ({ src, blur, subtleBlur, fade, className, imageClassName })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], blur && s['blur'], subtleBlur && s['subtle-blur'], fade && s['fade'], fade && s[`fade-${fade}`], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['image'], imageClassName),
        style: {
            backgroundImage: `url('${src}')`
        }
    }));
};
BackgroundImage.displayName = 'BackgroundImage';
export default BackgroundImage;

//# sourceMappingURL=BackgroundImage.js.map